export default {
  // 도메인 연결 상태
  DISCONNECTED: '미연결',
  WAITING: '연결중',
  CONNECTED: '연결완료',
  EXPIRATION: '기간만료',
};
